import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { TextArea, Checkbox } from "@/components";
import { DefaultProfile } from "@/images";
import { toast } from "react-toastify";
import {
  loggedInUser,
  addDirectMessage,
  upperCaseEachSentenceFirst,
} from "@/helpers";
import useAgentGitchaRestrictions from "@/hooks/useAgentGitchaRestrictions";
import { openModal } from "@/reducers/modals";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const SendMessage = ({ wantAd }) => {
  const [messageCharCount, setMessageCharCount] = useState(0);
  const [message, setMessage] = useState("");
  const [msgError, setMsgError] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const userAvatar = wantAd?.userAvatar;
  const wantCreatedFirstName = wantAd?.userFirstName;
  const wantCreatedUserName =
    wantAd?.userFirstName + " " + wantAd?.userLastName;
  const wantAdCompany = wantAd?.userCompany;
  const wantAdLicenseNo = wantAd?.LicenseNo;
  const wantAdPhone = wantAd?.userPhone;
  const agentSlug = wantAd?.userSlug;

  const userDetails = loggedInUser();

  const isLoggedIn = !!userDetails;

  const shouldDisableButton =
    !termsAccepted ||
    messageCharCount >= 2000 ||
    messageCharCount <= 0 ||
    isLoading ||
    !isLoggedIn;

  const onChangeText = (event) => {
    let value = event.target.value;

    value = upperCaseEachSentenceFirst(value);

    setMessage(value);
    setMessageCharCount(value.length);
  };

  const handleSendMessage = async () => {
    setIsLoading(true);
    const senderId = userDetails?.userInfo.userId;
    const receiverId = wantAd?.userId;

    const chatId =
      senderId < receiverId
        ? `${senderId}_${receiverId}`
        : `${receiverId}_${senderId}`;

    const messageData = {
      text: message,
      chatId: chatId,
      createdAt: new Date().getTime(),
      senderId,
      receiverId,
    };

    try {
      const response = await addDirectMessage(messageData);
      if (response === 1) {
        toast.success("Message sent successfully");
      } else {
        toast.error("Failed to send message");
      }
    } catch (error) {
      toast.error("An error occurred while sending the message");
      console.error(error);
    } finally {
      setMessage("");
      setIsLoading(false);
    }
  };

  const handleCheckboxClick = () => {

    if (!isLoggedIn) {
      return dispatch(openModal({ name: 'loginModal' }))
    }

    setTermsAccepted(!termsAccepted);
  };

  const dispatch = useDispatch()

  const handleTextAreaClick = () => {
    if (!isLoggedIn) {
      dispatch(openModal({ name: 'loginModal' }))
    }
  }

  const navigate = useNavigate()

  const { shouldRestrictAgent } = useAgentGitchaRestrictions();

  if (shouldRestrictAgent) {
    return null;
  }

  return (
    <div className="ad-strengthen-wrap mb-0 mb-sm-4">
      <div className="d-flex flex-column align-items-center">
        <div className="mb-2">
          <p className="f-medium f-size-18 send-message-listed-by">
            Listed By:
          </p>
          <p className="f-bold f-size-18 send-message-agent-username">
            {wantCreatedUserName}
          </p>
        </div>
        <img
          src={userAvatar || DefaultProfile}
          alt="avatar"
          className="property-agent-profile send-message-agent-profile mb-2"
          role="button"
          width="40"
          height="40"
          onClick={() => null}
        />
        <div className="d-flex flex-column align-items-center">
          <p className="send-message-company">{wantAdCompany}</p>
          <p className="send-message-license">{`Lic #${wantAdLicenseNo} `}</p>
          <a href={`tel:${wantAdPhone}`} className="send-message-phone">
            {wantAdPhone}
          </a>
          <a
            className="send-message-agent-bio"
            onClick={() => navigate(`/agent-info/${agentSlug}`, { state: { canGoBack: true }})}
            style={{ cursor: 'pointer' }}
          >
            {`View ${wantCreatedUserName}'s Full Bio`}{" "}
          </a>
        </div>
      </div>

      <div className="addyour-property-details-wrap mb-18 property-message">
        <label className="form-label">Message</label>
        <div onClick={handleTextAreaClick}>
          <TextArea
            name="message"
            id="message"
            className="form-control"
            errorMessage={msgError}
            value={message ? message : ""}
            maxLength={2000}
            placeholder={`Hi ${wantCreatedFirstName}, I have a few questions, when is a good time to connect?`}
            onChange={onChangeText}
          />
        </div>
        <div className="des-count align-self-end">{messageCharCount}/2000</div>
      </div>
      <div className="mb-18 d-flex flex-row justify-content-center align-items-center">
        <Checkbox
          className="form-check-input mb-8"
          checked={termsAccepted}
          onChange={(e) => handleCheckboxClick(e)}
        />
        <p className="send-message-checkbox-label">
          I agree to adhere to the{" "}
          <a className="send-message-checkbox-link" href="">
            Clear Cooperation Policy
          </a>{" "}
          in all correspondences.
        </p>
      </div>

      <div style={shouldDisableButton ? { cursor: 'not-allowed' } : {}}>
        <Button
          style={{ letterSpacing: "unset", pointerEvents: shouldDisableButton ? 'none' : 'auto', width: '100%' }}
          onClick={handleSendMessage}
          disabled={shouldDisableButton}
        >
          Send Message
        </Button>
      </div>
    </div>
  );
};

export default SendMessage;
